const EMOJI_PATTERN =
  /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2500}-\u{2BEF}\u{2702}-\u{27B0}\u{24C2}-\u{1F251}\u{1f926}-\u{1f937}\u{10000}-\u{10ffff}\u{2640}-\u{2642}\u{2600}-\u{2B55}\u{200d}\u{23cf}\u{23e9}\u{231a}\u{fe0f}\u{3030}]/u;

function isAllowedBannerNotesCharacter(char: string): boolean {
  if (/\s/u.test(char)) {
    return true;
  }
  if (EMOJI_PATTERN.test(char) || /\p{Extended_Pictographic}/u.test(char)) {
    return false;
  }
  if (/\p{Script=Latin}/u.test(char)) {
    return true;
  }
  if (/\p{M}/u.test(char)) {
    return true;
  }
  if (/\p{P}/u.test(char)) {
    return true;
  }
  if (/\p{S}/u.test(char)) {
    return true;
  }
  if (/\p{N}/u.test(char)) {
    return true;
  }
  return false;
}

export function formatInvalidBannerNotesCharacter(char: string): string {
  if (char.trim() !== "" && char.length <= 2) {
    return char;
  }
  const codePoint = char.codePointAt(0);
  if (codePoint === undefined) {
    return char;
  }
  return `\\u${codePoint.toString(16).toUpperCase().padStart(4, "0")}`;
}

export function findInvalidBannerNotesCharacter(
  text: string
): string | undefined {
  if (!text) {
    return undefined;
  }
  for (const char of text) {
    if (!isAllowedBannerNotesCharacter(char)) {
      return char;
    }
  }
  return undefined;
}
